


export const getEmptyZones = (masses: { int: number; mz: number }[]) => {
  let emptyZones: { start: number; end: number }[] = [];
  // add last peak to get emptyZones to 20'000
  const newMasses = [...masses, { mz: 20000, int: 0 }, { mz: 4000, int: 0 }];

  newMasses
      .sort((a, b) => a.mz - b.mz)
      .forEach(({ mz }, i) => {
        if (
            i + 1 !== newMasses.length &&
            Math.abs(mz - newMasses[i + 1].mz) > 800
        ) {
          emptyZones.push({ start: mz, end: newMasses[i + 1].mz });
        }
      });

  return emptyZones;
};

